module.exports = __webpack_public_path__ + "img/logo-icrea.fbed9526.svg";